var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4398 9.4594C12.5709 9.85473 11.6269 10.0581 10.6723 10.0557C6.95727 10.0516 3.9467 7.04153 3.94261 3.32715C3.94003 2.37268 4.14328 1.42889 4.53853 0.560093L4.7938 0L4.23268 0.252436C1.65684 1.41563 0.000928629 3.97915 3.96764e-07 6.80505C-0.00130493 10.7774 3.21838 13.9987 7.19142 14C10.0188 13.9982 12.5834 12.3418 13.7475 9.76566L14 9.20418L13.4398 9.4594ZM10.4987 12.6678C7.26205 14.4945 3.15712 13.3521 1.33004 10.116C-0.497039 6.87993 0.645644 2.77573 3.88227 0.948956C3.61326 1.71294 3.47672 2.51723 3.47849 3.32715C3.4831 7.29759 6.70117 10.5151 10.6723 10.5197C11.4823 10.5215 12.2868 10.385 13.0509 10.116C12.4484 11.1831 11.5659 12.0654 10.4987 12.6678Z",
    fill: "#009B94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.7fda3c472eb55a504ed317bae7892eba.svg";
export { ForwardRef as ReactComponent };